module.exports = __webpack_public_path__ + "img/personal12.c8877aa0.png";